import {TreeMapReduce} from "../utils/treeMapReduce";
import {setChecklistCompletion, setListCompletion, setSectionCompletion} from "../utils/completionStatusUtils";

export function setCompletionState(tree) {
	refreshCompletionState(tree);
}

export function refreshCompletionState(tree) {
	const d1 = new Date();
	refreshSectionsCompletionState(tree);
	refreshListsCompletionState(tree);
	refreshChecklistCompletionState(tree);
	const d2 = new Date();

	console.log("DIFF: " + (d2-d1));
}

export function refreshChecklistCompletionState(tree) {
	tree.set(["activity"],TreeMapReduce.map(setChecklistCompletion, tree.get(["activity"])));
}

export function refreshListsCompletionState(tree) {
	  tree.set(["activity"],TreeMapReduce.map(setListCompletion, tree.get(["activity"])));
}

export function refreshSectionsCompletionState(tree) {
	tree.set(["activity"],TreeMapReduce.map(setSectionCompletion, tree.get(["activity"])));
}